export default __webpack_public_path__ + "static/media/ir.0f53f204.png";